/// <reference types="vite/client" />

interface PlatformEnv {
  readonly VITE_API_URL?: string;
  readonly VITE_ADMIN_URL?: string;
  readonly VITE_WEBSITE_URL?: string;
}

const raw = import.meta.env as unknown as PlatformEnv;
const clean = (value: string | undefined) => (value ?? '').trim().replace(/\/+$/, '');

/** Build-time settings (.env.example). None of them is secret: they ship in the JavaScript. */
export const env = {
  /** '' = the API is on the platform's own origin (the dev proxy, or one Nginx host). */
  apiUrl: clean(raw.VITE_API_URL),
  adminUrl: clean(raw.VITE_ADMIN_URL) || 'https://vlmadmin.viganium.com',
  websiteUrl: clean(raw.VITE_WEBSITE_URL) || 'https://vlm.viganium.com',
} as const;
